module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst img = helpers.detectRenderedImage(model.logo, model._logo) || {}\nconst showAdminPanelButton = helpers.hasAccessTo('usage:adminPanel')\nconst userData = (storage.user || {}).data || {}\nlet userName = 'Anonymous'\nif(userData.firstName && userData.lastName){\nuserName =`${userData.firstName} ${userData.lastName}`\n} else if(userData.code) {\nuserName = userData.code\n} else if(userData.email) {\nuserName = userData.email\n}\n%><div><%\n%><div class=\"left\"><%\nif (img.url) {\n%><img class=\"logo\" src=\"<%- img.url %>\" alt=\"\" /><%\n}\n%><div class=\"version\"><%\n%><div class=\"main\"><%= model.title %> v<%= (storage.app || {}).version || '0.0.0' %></div><%\nif((storage.app || {}).upStartTimestamp){\n%><div class=\"sub\">vom <%= utils.moment((storage.app || {}).upStartTimestamp).format('DD.MM.YYYY') %></div><%\n}\n%></div><%\n%></div><%\n%><div class=\"right\"><%\n%><div class=\"main\"><%\nif(showAdminPanelButton){\n%><%- include('../../../base/form/elements/buttons',  { formMapping: { buttons: [{ buttonType: 'showAdminPanel', symbolOnly: true, icon: 'fi fi-adminPanel' }] } }) %><%\n}\n%><i class=\"heartbeatConnection fi fi-heartbeat-connection\"></i><%\n%><div class=\"user\"><%\n%><div class=\"text\"><%\n%><%- userName %><%\n%></div><%\nif(model.showProfileManagement){\n%><i class=\"fi fi-gear\"></i><%\n}\n%></div><%\n%></div><%\n%><div class=\"logout\"><%\n%><i class=\"fi fi-logout\"></i><%\n%></div><%\n%></div><%\n%></div>"
  , __filename = "components/templates/core/footer/footer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const img = helpers.detectRenderedImage(model.logo, model._logo) || {}
const showAdminPanelButton = helpers.hasAccessTo('usage:adminPanel')
const userData = (storage.user || {}).data || {}
let userName = 'Anonymous'
if(userData.firstName && userData.lastName){
userName =`${userData.firstName} ${userData.lastName}`
} else if(userData.code) {
userName = userData.code
} else if(userData.email) {
userName = userData.email
}

    ; __line = 13
    ; __append("<div>")
    ; 

    ; __line = 14
    ; __append("<div class=\"left\">")
    ; 
if (img.url) {

    ; __line = 16
    ; __append("<img class=\"logo\" src=\"")
    ; __append( img.url )
    ; __append("\" alt=\"\" />")
    ; 
}

    ; __line = 18
    ; __append("<div class=\"version\">")
    ; 

    ; __line = 19
    ; __append("<div class=\"main\">")
    ; __append(escapeFn( model.title ))
    ; __append(" v")
    ; __append(escapeFn( (storage.app || {}).version || '0.0.0' ))
    ; __append("</div>")
    ; 
if((storage.app || {}).upStartTimestamp){

    ; __line = 21
    ; __append("<div class=\"sub\">vom ")
    ; __append(escapeFn( utils.moment((storage.app || {}).upStartTimestamp).format('DD.MM.YYYY') ))
    ; __append("</div>")
    ; 
}

    ; __line = 23
    ; __append("</div>")
    ; 

    ; __line = 24
    ; __append("</div>")
    ; 

    ; __line = 25
    ; __append("<div class=\"right\">")
    ; 

    ; __line = 26
    ; __append("<div class=\"main\">")
    ; 
if(showAdminPanelButton){

    ; __line = 28
    ; __append( include('../../../base/form/elements/buttons',  { formMapping: { buttons: [{ buttonType: 'showAdminPanel', symbolOnly: true, icon: 'fi fi-adminPanel' }] } }) )
    ; 
}

    ; __line = 30
    ; __append("<i class=\"heartbeatConnection fi fi-heartbeat-connection\"></i>")
    ; 

    ; __line = 31
    ; __append("<div class=\"user\">")
    ; 

    ; __line = 32
    ; __append("<div class=\"text\">")
    ; 

    ; __line = 33
    ; __append( userName )
    ; 

    ; __line = 34
    ; __append("</div>")
    ; 
if(model.showProfileManagement){

    ; __line = 36
    ; __append("<i class=\"fi fi-gear\"></i>")
    ; 
}

    ; __line = 38
    ; __append("</div>")
    ; 

    ; __line = 39
    ; __append("</div>")
    ; 

    ; __line = 40
    ; __append("<div class=\"logout\">")
    ; 

    ; __line = 41
    ; __append("<i class=\"fi fi-logout\"></i>")
    ; 

    ; __line = 42
    ; __append("</div>")
    ; 

    ; __line = 43
    ; __append("</div>")
    ; 

    ; __line = 44
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/footer/footer.ejs

}